module.exports = __webpack_public_path__ + "static/img/s4.6510669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s4.png
// module id = i6Z3
// module chunks = 1